import { Injectable, computed, inject } from '@angular/core';
import { ADMIN_NAV_SECTIONS } from '@core/layout/admin-layout/admin-nav.config';
import { AuthService } from './auth.service';
import { hasPermission, isSuperAdminRole } from './permission.util';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly auth = inject(AuthService);

  readonly superAdmin = computed(() => {
    const user = this.auth.user();
    return isSuperAdminRole(user?.role, user?.roles);
  });

  can(recurso: string, accion = 'ver'): boolean {
    const user = this.auth.user();
    return hasPermission(user?.permisos, recurso, accion, { superAdmin: this.superAdmin() });
  }

  /** Primera ruta de menú con `ver`. */
  firstAllowedUrl(): string {
    for (const section of ADMIN_NAV_SECTIONS) {
      for (const item of section.items) {
        if (item.permission && this.can(item.permission, 'ver')) {
          return item.route;
        }
      }
    }
    return '/app/sin-acceso';
  }
}
